module.exports = __webpack_public_path__ + "static/media/counter_picture.fb07e81c.png";